/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} JohnexamplecomInputs */

const en_johnexamplecom = /** @type {(inputs: JohnexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`john@example.com`)
};

const de_johnexamplecom = /** @type {(inputs: JohnexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`john@example.com`)
};

/**
* | output |
* | --- |
* | "john@example.com" |
*
* @param {JohnexamplecomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const johnexamplecom = /** @type {((inputs?: JohnexamplecomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<JohnexamplecomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_johnexamplecom(inputs)
	return de_johnexamplecom(inputs)
});